var map = {
	"./multiplier_0_en.png": 72259,
	"./multiplier_0_th.png": 17530,
	"./multiplier_0_zh.png": 83908,
	"./multiplier_3_en.png": 98722,
	"./multiplier_3_th.png": 58255,
	"./multiplier_3_zh.png": 32677,
	"./multiplier_5_en.png": 26736,
	"./multiplier_5_th.png": 16769,
	"./multiplier_5_zh.png": 86259,
	"./multiplier_8_en.png": 89643,
	"./multiplier_8_th.png": 65090,
	"./multiplier_8_zh.png": 67772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14011;